module.exports = __webpack_public_path__ + "img/pic4.5085b45c.jpg";